import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

export const sidebarMenuSlice = createSlice({
    name: "sidebarMenu",
    initialState: {
        menuItems: [],
        menuLoading: false,
        menuError: null,
    },
    reducers: {
        setMenuLoading: (state) => {
            state.menuLoading = true;
            state.menuError = null;
        },
        setMenuItems: (state, action) => {
            state.menuItems = action.payload;
            state.menuLoading = false;
        },
        setMenuError: (state, action) => {
            state.menuError = action.payload;
            state.menuLoading = false;
        },
        clearMenu: (state) => {
            state.menuItems = [];
            state.menuLoading = false;
            state.menuError = null;
        },
    },
});

export const fetchMyMenu = () => async (dispatch) => {
    try {
        dispatch(setMenuLoading());
        const response = await axios.get("/api/admin/sidebar-menu/my-menu");
        dispatch(setMenuItems(response.data.menu_items));
    } catch (error) {
        dispatch(setMenuError(error.response?.data?.errorMessage || "Failed to load menu"));
    }
};

export const { setMenuLoading, setMenuItems, setMenuError, clearMenu } = sidebarMenuSlice.actions;

export const getMenuItems = (state) => state.sidebarMenu?.menuItems;
export const getMenuLoading = (state) => state.sidebarMenu?.menuLoading;
export const getMenuError = (state) => state.sidebarMenu?.menuError;

export default sidebarMenuSlice.reducer;
